<template lang="pug">
div( class="ibox" )
  div( class="ibox-content" )
    div( v-if="loading" class="text-center" )
      | Loading...
    
    div( v-else class="d-flex justify-content-between align-items-center" )
      div
        h3( class="m-0" ) AI Analysis and Actions on Batch
      div
        button( class="btn btn-primary" )
          MMoonpullIcon( class="mr-2" )
          | Perform AI Actions
    
    div( class="mt-2" )
      | Hello

</template>

<style lang="scss">
.break-word {
  word-break: break-word;
}
</style>

<script>
import Vue from 'vue'
import { onMounted, ref } from '@vue/composition-api'
import { api } from '@/api'
export default Vue.extend({
  
  props: {
    batchId: {
      type: String,
      required: true
    },
  },

  setup(props) {
    
    const { batchId } = props
    const loading = ref(true)
    const error = ref()
    const aiQuestionResults = ref([])
    onMounted(async () => {
      try {
        const res = await api('GET', `/gemini/ai-questions/batches/${batchId}`)
        if (!res.ok) {
          error.value = await res.text()
          return
        }
        aiQuestionResults.value = await res.json()
      } catch (e) {
        console.error(`aiAskQuestionsAndDoActions`, e)
        error.value = e.message
      } finally {
        loading.value = false
      }
    })

    async function aiAskQuestionsAndDoActions() {
      loading.value = true
      try {
        const res = await api('POST', `/gemini/ai-questions/audits/${batchId}`)
        if (!res.ok) {
          error.value = await res.text()
          return
        }
        aiQuestionResults.value = await res.json()
        error.value = ''
      } catch (e) {
        console.error(`aiAskQuestionsAndDoActions`, e)
        error.value = e.message
      } finally {
        loading.value = false
      }
    }

    return {
      loading,
      aiQuestionResults,
      aiAskQuestionsAndDoActions,
      error,
    }
  }
})
</script>